import React, { Component } from 'react';
import { Row, Col, Form, Card, Divider, Icon } from 'antd';

export default class EmailChangeNotice extends Component {
    constructor(props) { super(props); }
    render() {
        return (
            <div>
                <div style={{
                    boxShadow: 'rgb(184, 184, 184) 0px 0px 20px',
                    borderRadius: '10px',
                    borderStyle: 'solid',
                    borderColor: 'rgb(200, 200, 200)',
                    borderWidth: '1px'
                }}>
                    <Card style={{
                        borderRadius: '10px',
                        borderStyle: 'solid',
                        borderColor: 'rgb(255, 255, 255)',
                        borderWidth: '1px',
                        lineHeight: '16px'
                    }}>
                        <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '20px' }}>
                            <Col style={{ width: '300px' }}>
                                <Divider style={{ margin: '0px', fontSize: '18px', fontWeight: 'bold', color: 'rgb(90, 90, 90)' }}>
                                    <Icon type='info-circle-o' style={{ marginRight: '8px' }} />
                                    {'Notice'}
                                </Divider>
                            </Col>
                        </Row>
                        <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '20px' }}>
                            <Col style={{ width: '300px' }}>
                                {'Please enter the following information to help us verify your identity. '}
                                <span style={{ fontWeight: 'bold' }}>
                                    {'Candidates must provide their current passport number and country below.'}
                                </span>
                            </Col>
                        </Row>
                        <Row type='flex' justify='space-around' align='middle'>
                            <Col style={{ width: '300px' }}>
                                {'FTSP will send notification of the address change to both the new and old email addresses. '}
                            </Col>
                        </Row>
                    </Card>
                </div>
            </div>
        );
    }
}
